// extracted by mini-css-extract-plugin
module.exports = {"controlButton":"controlButton___Zup3p","buttonWrap":"buttonWrap___18yYB","frame":"frame___1bpLD"};